<script lang="ts" setup>
import {computed} from 'vue';
import {useI18n} from 'vue-i18n';
import {progressFractionToPct} from '@/ts/utils/pure-functions';

const props = defineProps<{
  /** Completion as a 0–1 fraction (matches the BE `pctCompletionProgress`). */
  value: number;
}>();

const {t: $t} = useI18n();

const pct = computed<number>(() => progressFractionToPct(props.value));
</script>

<template>
  <div class="recco-progress">
    <div class="recco-progress__label">
      {{ $t('complete_n', {n: pct}) }}
    </div>
    <div
      class="recco-progress__track"
      role="progressbar"
      :aria-label="$t('complete_n', {n: pct})"
      :aria-valuenow="pct"
      aria-valuemin="0"
      aria-valuemax="100"
    >
      <div class="recco-progress__fill" :style="{width: `${pct}%`}"/>
    </div>
  </div>
</template>

<style lang="scss" scoped>
// Progress indicator for started challenges/programs (IPD-2943). Theme-aware neutral
// fill on a translucent track — matches the design's 6px bar.
.recco-progress {
  width: 100%;
}

.recco-progress__label {
  @include font-body-sm-bold;
  margin-bottom: var(--Spacing-spacing-2);
}

.recco-progress__track {
  height: 6px;
  border-radius: 999px;
  background: color-mix(in srgb, var(--Neutral-UI-neutral-ui-100) 16%, transparent);
  overflow: hidden;
}

.recco-progress__fill {
  height: 100%;
  border-radius: 999px;
  background: var(--Neutral-UI-neutral-ui-100);
  transition: width 0.4s ease;
}
</style>
